import React from 'react'
import { useParams } from 'react-router-dom'
import styles from './GeoHeader.module.scss'
import Content from '../../../components/Content'

import Layout from '../../../components/Layout'
import GeoProvider from '../../../components/GeoProvider'
import DashboardMap from './DashboardMap'
import dataDisplayOptions from '../dataDisplayOptions'
import { startDate, endDate } from '../dates'
import Header from './Header'
import VulnerabilityBreakdown from './VulnerabilityBreakdown'
import SystemNotification from './../../Dashboard/SystemNotification'
import BelowMapNotification from '../../Dashboard/BelowMapNotification'
const VulnerabilityMsaDashboard = () => {
  const { geo_parent, area, loc } = useParams()

  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              isChecked={false}
              displayDate={"2025-01-01"}
              locationName={loc}
              mapOptions={dataDisplayOptions[0]['options'][1]}
              indicatorName={dataDisplayOptions[0]['options'][1].indicatorName}
              regionSelected={'state'}
            >
              <SystemNotification/>
              <Header headerType={geo_parent} headerNumber={3} geo_id={loc} />

              <DashboardMap
                geo_type={area}
                geo_parent={geo_parent}
                zoomLocation={loc}
              />
              <BelowMapNotification message_type='MONTHLY'/>
              <VulnerabilityBreakdown geo_type={area} geo_id={loc}/>
             
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default VulnerabilityMsaDashboard
